export default __webpack_public_path__ + "static/media/brain-test@2x.9990d44d.webp";